module.exports = __webpack_public_path__ + "media/images/lb/647-5599da04e26f60781af108570d9ccea3.svg";